export const EXPORTS_CREATE_FORM = 'EXPORTS_CREATE_FORM';
export const TIME_PERIOD_ALL_TIME = 'all_time';
export const TIME_PERIOD_PRE_DEFINED_REG_EXP = /^last_\d+$/;
export const TIME_PERIOD_CUSTOM = 'custom';
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD';
